import React, { useState } from 'react';
import { Navigation } from 'lucide-react';

const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Small embedded Google map with the driving route drawn (Maps Embed API — no usage cost).
export const RouteMap = ({ from, to, label, className = '' }) => {
  const [loaded, setLoaded] = useState(false);
  if (!KEY || !from || !to) return null;
  const src = `https://www.google.com/maps/embed/v1/directions?key=${KEY}&origin=${encodeURIComponent(from)}&destination=${encodeURIComponent(to)}&mode=driving&region=CH`;
  return (
    <div className={`rounded-2xl overflow-hidden border border-gray-100 bg-[color:var(--brand-muted)] ${className}`} data-testid="route-map">
      <div className="flex items-center gap-2 px-4 py-2.5 text-xs font-bold text-[color:var(--brand-dark)]">
        <Navigation className="w-3.5 h-3.5" style={{ color: 'var(--brand-accent)' }} /> {label || `${from} → ${to}`}
      </div>
      <div className="relative h-56 sm:h-64">
        {!loaded && <div className="absolute inset-0 animate-pulse bg-gray-200" />}
        <iframe
          title={`Route ${from} → ${to}`}
          src={src}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={() => setLoaded(true)}
          className="absolute inset-0 w-full h-full border-0"
          data-testid="route-map-iframe"
        />
      </div>
    </div>
  );
};

export default RouteMap;
